import React from 'react'
import { connect } from 'react-redux'

import { doStartEditing } from 'ducks/inAppCards/customer'
import { selectCurrentCustomerId } from 'selectors/tickets'
import { propFunc } from 'util/functions'

import styles from './styles.css'

const NoCustomerEmail = ({ customerId, onClick }) => {
  return (
    <div className={styles.warning}>
      <a href="#" onClick={propFunc(onClick, customerId)}>
        <b>Invalid customer email:</b>&nbsp;
        <span>to reply, please click here to update their email address</span>
      </a>
    </div>
  )
}

const select = state => {
  return {
    customerId: selectCurrentCustomerId(state),
  }
}

const perform = {
  onClick: doStartEditing,
}

export default connect(select, perform)(NoCustomerEmail)
